import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import LoginPicture from "../../images/DoctorImage.svg";
import { Form, Input, message } from "antd";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getLogin } from "../../api/Login";
import useAuthService from "../../session/useAuthService";
import Loader from "../../customJS/Loader";

function Login() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = (values) => {
    var loginUser = {
      email: values.username,
      password: CryptoJS.MD5(values.password).toString(),
    };
    console.log("LOGINUSER:", loginUser, values);

    setLoader(true);
    getLogin(loginUser)
      .then((response) => {
        var result = response.data;
        if (response.data.status === 1) {
          // useAuthService.registerAuth(result.data);
          // console.log(useAuthService.registerToken);

          useAuthService.registerToken(result.data.token);
          if (result.data.uType === "1") {
            navigate("/admin/newRequest");
          }else if (result.data.uType === "2") {
            navigate("/clinic/providers");
          }else if (result.data.uType === "3"){
            navigate("/clinic/providers");
          }
        } else if (response.data.status === 2) {
          messageApi.open({
            type: "error",
            content: "The user does not have access to log in.",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else if (response.data.status === -1) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        } else if (response.data.status === -2) {
          messageApi.open({
            type: "error",
            content: response.data.message,
            duration: 1,
            className: "ant-alert",
          });
          console.log(
            "Your account has been deleted. Please contact the administrator for help"
          );
          setLoader(false);
        } else {
          messageApi.open({
            type: "error",
            content: "Please try with valid credentials.",
            duration: 1,
            className: "ant-alert",
          });
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        messageApi.open({
          type: "error",
          content: "Network error, Please try again later.",
          duration: 1,
          className: "ant-alert",
        });
        setLoader(false);
      });
    // console.log("Success:", loginUser);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Prevent form submission when pressing Enter
      event.preventDefault();
    }
  };

  const handleLoginPress = (e) => {
    console.log("event",e);
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission
      onFinish() // Trigger form submission
    }
  };

  return (
    <Row className="m-0 d-flex justify-content-center align-items-center">
      {contextHolder}
     {loader && <Loader />}
      <Col lg={6} className="h-100">
        <div className="h-100 mx-md-5 px-md-5 align-content-center">
            <h2 className="uniteColor font-family-Mar mb-3">Log in to your account</h2>
          <div className="fromData">
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
              // style={{ maxWidth: 400, margin: "0 auto" }}
              onKeyDown={handleKeyDown} // Prevent Enter key default action
            >
              <Form.Item
                name="username"
                // label="Email"
                label="Provider’s office email"
                rules={[
                  { required: true, message: "Please input your username!" },
                ]}
              >
                <Input placeholder="Enter your username" onKeyPress={handleLoginPress} autoComplete="off" />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: "Please input your password!" },
                ]}
              >
                <Input.Password
                  placeholder="Enter your password"
                  autoComplete="off"
                  onKeyPress={handleLoginPress}
                />
              </Form.Item>
              <Form.Item>
                <span style={{ cursor: "pointer", color: "#3f4f73" }} 
                onClick={()=> navigate("/resetPassword")}
                >
                  Reset Password
                </span>
                <div className="mt-3">
                  <Button
                    type="primary"
                    disabled={loader}
                    className="uniteButton me-3" // Submit form only when Login is clicked
                  >
                    Login
                  </Button>
                  <Button type="button" 
                  onClick={()=> navigate("/signup")} className="uniteButton-outline">
                    New Here? Join Now
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Col>
      <Col lg={6} className="d-flex justify-content-center">
        <img src={LoginPicture} alt="doctor image.png" height="500" width="500"/>
      </Col>
    </Row>
  );
}

export default Login;
